﻿import {EventEmitter} from "@angular/core";
import {ValidationMessage} from "./validationMessage";


export interface INotifyError {
    validationMessages: ValidationMessage[];
    addValidationMessage(vm: ValidationMessage | ValidationMessage[], notify: boolean): void;
    removeValidationMessage(vm: ValidationMessage | ValidationMessage[], notify: boolean): void;
    clear();
    notifier: EventEmitter<ErrorNotification>;
}

export enum ErrorAction {
    Added,
    Removed,
    Clear,
}

export class ErrorNotification {
    constructor(public validationMessage: ValidationMessage, public action= ErrorAction.Added) {}
}
